<template>
  <v-card elevation="0" class="mb-4">
    <v-card-text>
      <v-row style="min-height: 450px">
        <v-col md="12">
          <!-- Consumos Adicionales -->
          <h6 class="text-h6 black--text">Consumos Adicionales</h6>
          <v-btn color="primary" @click="openAddModal" small class="mb-4" v-if="!view_finish_order">
            <v-icon left small>add</v-icon>
            Agregar Consumo Adicional
          </v-btn>
       
          <v-data-table
            :headers="headersConsumptions"
            :items="additionalItems"
            :items-per-page="-1"
            hide-default-footer
            style="border: solid 1px #1c1c1c"
            class="mb-6"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>
                    <div>{{ item.type ? getTypeName(item.type.id, item) : "-" }}</div>
                    <div class="text-caption">{{ item.type ? getTypeText(item.type.id) : "-" }}</div>
                </td>
                <td>{{ getPresentationName(item) }}</td>
                <td class="text-right">{{ item.valor_utilizado || "-" }}</td>
                <td>{{ getStorageUnit(item) }}</td>
                <td class="text-right">$ {{ item.costo_base || "0.00" }}</td>
                <td class="text-right">$ {{ item.costo_unitario_utilizado || "0.00" }}</td>
                <td>{{ item.observacion || "-" }}</td>
                <td class="text-center" v-if="!view_finish_order">
                  <v-icon
                    small
                    color="blue"
                    class="mr-2"
                    @click="editItem(item, index)"
                  >
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="removeItem(index)">
                    delete
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>

          <!-- Costos Adicionales -->
          <h6 class="text-h6 black--text mt-6">Costos Adicionales</h6>
          <v-btn color="primary" @click="openAddCostModal" small class="mb-4" v-if="!view_finish_order">
            <v-icon left small>add</v-icon>
            Agregar Costo Adicional
          </v-btn>

          <v-data-table
            :headers="headersCosts"
            :items="additionalCosts"
            :items-per-page="-1"
            hide-default-footer
            style="border: solid 1px #1c1c1c"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ item.observacion_resultado || "-" }}</td>
                <td class="text-right">$ {{ item.value_used || "-" }}</td>
                <td class="text-center" v-if="!view_finish_order">
                  <v-icon
                    small
                    color="blue"
                    class="mr-2"
                    @click="editCost(item, index)"
                  >
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="removeCost(index)">
                    delete
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <div class="row justify-content-center mt-4">
        <div class="col-md-12">
          <v-btn color="primary" @click="$emit('prevStep')" small>
            Volver
          </v-btn>
        </div>
      </div>
    </v-card-text>

    <ModalAddConsumption
      :dialog="dialogAddConsumption"
      :itemEdit="itemToEdit"
      :editIndex="editIndex"
      @updateDialog="updateDialogAddConsumption"
      @addItem="addItemToList"
      @updateItem="updateItemInList"
    />

    <ModalAddCost
      :dialog="dialogAddCost"
      :itemEdit="costToEdit"
      :editIndex="editCostIndex"
      @updateDialog="updateDialogAddCost"
      @addItem="addCostToList"
      @updateItem="updateCostInList"
    />
  </v-card>
</template>

<script>
import ModalAddConsumption from "./ModalAddConsumption.vue";
import ModalAddCost from "./ModalAddCost.vue";
import { FORMULA_ITEM_TYPE_CONFIG as TYPE_CONFIG } from "@/constants/formulaItemTypes";

export default {
  name: "StepConsumosAdicionales",
  components: {
    ModalAddConsumption,
    ModalAddCost,
  },
  props: {
    productionOrder: {
      type: Object,
      default: null,
    },
    mainItem: {
      type: Object,
      required: true,
    },
    view_finish_order: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headersConsumptions: [
        { text: "Tipo", value: "tipo", align: "left", sortable: false },
        {
          text: "Producto",
          value: "mp_product_presentation_used",
          align: "left",
          sortable: false,
        },
       
        {
          text: "Cantidad Utilizada",
          value: "valor_utilizado",
          align: "right",
          sortable: false,
        },
         {
          text: "Unidad",
          value: "storage_unit",
          align: "left",
          sortable: false,
        },
        {
          text: "Costo Base",
          value: "costo_base",
          align: "right",
          sortable: false,
        },
        {
          text: "Costo Utilizado",
          value: "costo_unitario_utilizado",
          align: "right",
          sortable: false,
        },
        {
          text: "Observaciones",
          value: "observacion",
          align: "left",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      headersCosts: [
        {
          text: "Descripcion",
          value: "observacion_resultado",
          align: "left",
          sortable: false,
        },
        {
          text: "Costo",
          value: "value_used",
          align: "right",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      dialogAddConsumption: false,
      itemToEdit: null,
      editIndex: null,
      dialogAddCost: false,
      costToEdit: null,
      editCostIndex: null,
    };
  },
  computed: {
    additionalItems() {
      return this.mainItem.additional_consumptions || [];
    },
    additionalCosts() {
      return this.mainItem.additional_costs || [];
    },
  },
  methods: {
    getTypeName(type, item) {
      const config = TYPE_CONFIG[type];
      if (!config) return type;
      
      const entity = item[config.entityKey];
      return entity?.label || entity?.name || type;
    },
    getTypeText(type) {
      return TYPE_CONFIG[type]?.name || type;
    },
    getPresentationName(item) {
      if (item.mp_product_presentation_used && typeof item.mp_product_presentation_used === 'object') {
        return item.mp_product_presentation_used.label || item.mp_product_presentation_used.name || "-";
      }
      return "-";
    },
    getStorageUnit(item) {
      const typeId = item.type?.id;
      const config = TYPE_CONFIG[typeId];
      
      if (!config || !config.unitKey) return '-';
      
      // Para recursos, el unitKey es 'resource_unit'
      if (typeId === 'R') {
        const entity = item[config.entityKey];
        const unit = entity?.[config.unitKey];
        return unit?.name || '-';
      }
      
      // Para otros tipos (M, S, P), el unitKey es 'storage_unit'
      console.log('item:', item);
      const entity = item[config.entityKey];
      if (!entity) return '-';
      
      const unit = entity[config.unitKey];
      return unit?.name || '-';
    },
    // Métodos para consumos adicionales
    openAddModal() {
      this.itemToEdit = null;
      this.editIndex = null;
      this.dialogAddConsumption = true;
    },
    editItem(item, index) {
      this.itemToEdit = Object.assign({}, item);
      this.editIndex = index;
      this.dialogAddConsumption = true;
    },
    updateDialogAddConsumption(value) {
      this.dialogAddConsumption = value;
      if (!value) {
        this.itemToEdit = null;
        this.editIndex = null;
      }
    },
    addItemToList(item) {
      if (!this.mainItem.additional_consumptions) {
        this.$set(this.mainItem, "additional_consumptions", []);
      }
      this.mainItem.additional_consumptions.push(item);
    },
    updateItemInList(item, index) {
      this.$set(this.mainItem.additional_consumptions, index, item);
    },
    removeItem(index) {
      this.mainItem.additional_consumptions.splice(index, 1);
    },
    // Métodos para costos adicionales
    openAddCostModal() {
      this.costToEdit = null;
      this.editCostIndex = null;
      this.dialogAddCost = true;
    },
    editCost(item, index) {
      this.costToEdit = Object.assign({}, item);
      this.editCostIndex = index;
      this.dialogAddCost = true;
    },
    updateDialogAddCost(value) {
      this.dialogAddCost = value;
      if (!value) {
        this.costToEdit = null;
        this.editCostIndex = null;
      }
    },
    addCostToList(item) {
      if (!this.mainItem.additional_costs) {
        this.$set(this.mainItem, "additional_costs", []);
      }
      this.mainItem.additional_costs.push(item);
    },
    updateCostInList(item, index) {
      this.$set(this.mainItem.additional_costs, index, item);
    },
    removeCost(index) {
      this.mainItem.additional_costs.splice(index, 1);
    },
  },
};
</script>

<style scoped></style>
